var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransmission = function SvgTransmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.4a2.2 2.2 0 0 0-1 4.16v2.24a1 1 0 1 0 2 0V8.56a2.2 2.2 0 0 0-1-4.16Z",
    fill: "#F08200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.56a2.2 2.2 0 1 1 2 0v3.04h3.2a.8.8 0 0 0 .8-.8V8.56a2.2 2.2 0 1 1 2 0v2.24a2.8 2.8 0 0 1-2.8 2.8h-3.2v1.84a2.2 2.2 0 1 1-2 0V13.6h-3.2a.8.8 0 0 0-.8.8v1.04a2.2 2.2 0 1 1-2 0V14.4a2.8 2.8 0 0 1 2.8-2.8h3.2V8.56Z",
    fill: "#F08200"
  })));
};
export default SvgTransmission;